import React from 'react';
import PropTypes from "prop-types";
import {Link, useSearchParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {ReloadListAction} from "mindsets-js-sdk";

function Row({item, row_number}) {
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();

    function renderLesson() {
        if (item.lesson) {
            return (
                <div className='d-flex justify-content-between flex-gap-10'>
                    <div>{item.lesson.code} ({item.lesson.id})</div>
                    <button className='small' onClick={() => {
                        const searchParams = new URLSearchParams;
                        searchParams.set('column~0', 'lesson_id');
                        searchParams.set('expression~0', 'eq');
                        searchParams.set('value~0', item.lesson.id);
                        setSearchParams(searchParams);
                        dispatch(ReloadListAction('action_logs'));
                    }} title='Show all actions for this class'>
                        <i className='fas fa-filter'/>
                    </button>
                </div>
            );
        }

        return 'n/a';
    }

    function renderChallenge() {
        if (item.challenge_version) {
            let content = item.challenge_version.name + '(v.' + item.challenge_version.version + ')';
            if (item.challenge_version.challenge_code) {
                content += ' ' + item.challenge_version.challenge_code.code;
            }

            return content;
        }

        return 'n/a';
    }

    return (
        <tr>
            <td>{row_number}</td>
            <td>{item.id}</td>
            <td>
                <div className='d-flex justify-content-between flex-gap-10'>
                    <Link
                        to={'/users/' + item.user.id}
                        data-bs-toggle="tooltip"
                        data-placement="top"
                        title="Edit teacher"
                    >{item.user.fname + ' ' + item.user.lname}</Link>
                    <button className='small' onClick={() => {
                        const searchParams = new URLSearchParams;
                        searchParams.set('column~0', 'user_id');
                        searchParams.set('expression~0', 'eq');
                        searchParams.set('value~0', item.user.id);
                        setSearchParams(searchParams);
                        dispatch(ReloadListAction('action_logs'));
                    }} title='Show all actions of this user'>
                        <i className='fas fa-filter'/>
                    </button>
                </div>
            </td>
            <td>{item.action_name}</td>
            <td>{renderChallenge()}</td>
            <td>{renderLesson()}</td>
            <td>{item.stream_id}</td>
            <td>{item.stream_index >= 0 ? item.stream_index : 'n/a'}</td>
            <td className='no-wrap'>{new Date(item.created_at * 1000).toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                'minute': 'numeric'
            })}</td>
        </tr>
    );
}

Row.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number.isRequired,
        created_at: PropTypes.number.isRequired,
        action_name: PropTypes.string.isRequired,
        user: PropTypes.shape({
            id: PropTypes.number.isRequired,
            fname: PropTypes.string,
            lname: PropTypes.string,
            email: PropTypes.string.isRequired
        }).isRequired,
        challenge_version: PropTypes.shape({
            name: PropTypes.string.isRequired,
            version: PropTypes.number.isRequired,
            challenge_code: PropTypes.shape({
                code: PropTypes.string.isRequired
            }).isRequired
        }),
        lesson: PropTypes.shape({
            id: PropTypes.number.isRequired,
            code: PropTypes.string.isRequired
        }),
        stream_id: PropTypes.number,
        stream_index: PropTypes.number
    }).isRequired,
    row_number: PropTypes.number.isRequired
};

export default Row;
